/**
 * Strategic Statuses Form JavaScript
 * 
 * This file handles the dynamic behavior of the strategic statuses form, specifically for managing sub-statuses.
 * It provides functionality to add new sub-statuses, remove existing ones, and manage custom color settings.
 * 
 * Key features:
 * - Adds new sub-statuses with a template
 * - Removes sub-statuses
 * - Toggles custom color picker visibility based on checkbox state
 * - Updates sub-status colors when the parent color changes (inheritance)
 * 
 * Dependencies:
 * - jQuery
 * - Turbolinks
 */

$(document).on('turbolinks:load', function() {
  // Cache DOM elements for better performance first
  const $subStatusTemplate = $('.sub-status-template');
  const $subStatusesList = $('.sub-statuses-list');
  const $addSubStatusButton = $('.add-sub-status');
  const $parentColorInput = $('#parent-color-input');

  // Only run on pages with the sub-statuses-container OR when editing/creating sub-status
  const isSubStatusForm = $parentColorInput.length && $parentColorInput.data('parent-color');
  const isParentStatusForm = $('.sub-statuses-container').length > 0;
  
  if (!isSubStatusForm && !isParentStatusForm) return;

  /**
   * Gets the current color value from the parent status color picker
   * @returns {string} The hex color value from the parent color picker
   */
  function getParentColor() {
    // If it's a sub-status form, use the parent color from data attribute
    const parentColor = $parentColorInput.data('parent-color');
    if (parentColor) {
      return parentColor;
    }
    return $parentColorInput.val() || '#000000';
  }

  /**
   * Initializes the color for sub-status creation/editing
   */
  function initializeSubStatusColor() {
    const parentColor = $parentColorInput.data('parent-color');
    if (parentColor) {
      // If no color is set for sub-status, use parent color as default
      if (!$parentColorInput.val() || $parentColorInput.val() === '') {
        $parentColorInput.val(parentColor);
      }
      console.log('Sub-status initialized with color:', $parentColorInput.val());
    }
  }

  /**
   * Updates inherited color displays for a specific sub-status item
   * @param {jQuery} $item - The sub-status item to update
   */
  function updateInheritedColorDisplay($item) {
    const parentColor = getParentColor();
    console.log(parentColor);
    $item.find('.inherited-color-display').val(parentColor);
    $item.find('.sub-status-color').val(parentColor);
  }

  /**
   * Toggles between custom color and inherited color for a sub-status
   * @param {jQuery} $checkbox - The checkbox that was toggled
   */
  function toggleColorMode($checkbox) {
    const $item = $checkbox.closest('.sub-status-item');
    const $colorPickerContainer = $item.find('.color-picker-container');
    const $inheritedColorInfo = $item.find('.inherited-color-info');
    
    if ($checkbox.is(':checked')) {
      // Show custom color picker
      $colorPickerContainer.show();
      $inheritedColorInfo.hide();
    } else {
      // Show inherited color info and update values
      $colorPickerContainer.hide();
      $inheritedColorInfo.show();
      updateInheritedColorDisplay($item);
    }
  }

  /**
   * Adds a new sub-status to the form
   * Clones the template, initializes its state, and appends it to the list
   */
  $addSubStatusButton.off('click').on('click', function() {
    const $newItem = $subStatusTemplate.find('.sub-status-item').clone();
    $newItem.css('display', 'block');
    
    // Generate unique IDs for form elements
    const timestamp = Date.now();
    const $checkbox = $newItem.find('input.use-custom-color');
    const checkboxId = `use_custom_color_${timestamp}`;
    $checkbox.attr('id', checkboxId);
    $newItem.find('label').first().attr('for', checkboxId);
    
    // Initialize the new sub-status with inherited color by default
    $checkbox.prop('checked', false);
    updateInheritedColorDisplay($newItem);
    
    // Set initial state - show inherited color info
    $newItem.find('.color-picker-container').hide();
    $newItem.find('.inherited-color-info').show();
    
    $subStatusesList.append($newItem);
  });

  /**
   * Handles the removal of sub-statuses
   * Uses event delegation to handle dynamically added remove buttons
   */
  $subStatusesList.off('click', '.remove-sub-status').on('click', '.remove-sub-status', function() {
    $(this).closest('.sub-status-item').remove();
  });
  
  /**
   * Manages the custom color picker visibility and value for sub-statuses
   * When unchecked, uses the parent status color
   * When checked, shows the custom color picker
   */
  $subStatusesList
    .off('change', 'input.use-custom-color')
    .on('change', 'input.use-custom-color', function(event) {
      toggleColorMode($(this));
    });
  
  /**
   * Initializes the state of existing sub-status checkboxes on page load
   * Sets up the initial visibility of color pickers and their values
   */
  $('.sub-statuses-list input.use-custom-color').each(function() {
    toggleColorMode($(this));
  });

  /**
   * Updates all sub-statuses using inherited colors when the parent color changes
   * This ensures that sub-statuses using the parent color stay in sync
   */
  $parentColorInput.on('input change', function() {
    const newColor = $(this).val();
    $('.sub-statuses-list .sub-status-item').each(function() {
      const $item = $(this);
      const $checkbox = $item.find('input.use-custom-color');
      
      if (!$checkbox.is(':checked')) {
        updateInheritedColorDisplay($item);
      }
    });
  });
  
  // Initialize sub-status color if this is a sub-status form
  if (isSubStatusForm) {
    initializeSubStatusColor();
  }

  // Initialize parent color on load for parent status forms
  if (isParentStatusForm && $parentColorInput.length && $parentColorInput.val()) {
    $parentColorInput.trigger('change');
  } else if (isParentStatusForm && $parentColorInput.length && !$parentColorInput.val()) {
    // Set default color if no color is set
    $parentColorInput.val('#007bff').trigger('change');
  }
}); 